<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';
  import { transformListKey } from '$shared/helpers/ListKeyFormat';
  import { parseDynamicData } from '$shared/helpers/utils';

  interface Props {
    value?: ObjectType<string>;
    name?: string;
  }

  let { value = {}, name = '' }: Props = $props();
</script>

<div class="comp-entity-object-type" data-cy={name}>
  {#each Object.entries(value) as [key, value]}
    <div class="entity-object-i">
      <div data-cy={`${key}-k`} class="key">
        {transformListKey(key)}
      </div>
      <div data-cy={`${key}-v`} class="value">{parseDynamicData(value)}</div>
    </div>
  {:else}
    {EmptyLabelDefault}
  {/each}
</div>

<style>
  .comp-entity-object-type {
    width: 100%;
  }
  .entity-object-i {
    display: flex;
    align-items: flex-start;
    padding: 9px 16px;
    line-height: 20px;
    color: var(--grey-dark);
  }

  .entity-object-i .key {
    width: 150px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }

  .entity-object-i .value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
